/**
 * Configuração para controle de anúncios na aplicação
 * 
 * Este arquivo permite ativar/desativar facilmente os anúncios durante o desenvolvimento,
 * evitando erros no console e travamentos quando o AdSense não está disponível
 */

// Ambiente atual da aplicação
const isDevelopment = process.env.NODE_ENV === 'development';

const adsConfig = {
  // Ativar ou desativar todos os anúncios
  enabled: !isDevelopment, // Desabilitado por padrão em ambiente de desenvolvimento
  
  // ID da conta do AdSense (substituir pelo seu ID quando disponível)
  adClientId: 'ca-pub-SEUCODIGO', 
  
  // Configuração de slots específicos
  slots: {
    headerBanner: '1234567890',
    footerBanner: '0987654321',
    sidebar: '1122334455',
    inContent: '5566778899',
  },
  
  // Tempo máximo (em ms) para verificar se o AdSense está carregado antes de desistir
  adSenseLoadTimeout: 2000,
  
  // Forçar modo de demonstração mesmo em produção (para testes)
  forceDemoMode: false,
  
  // Opções de exibição de placeholder quando os anúncios estão desabilitados
  placeholder: {
    show: true, // Mostrar elemento placeholder no lugar dos anúncios quando desativados
    label: 'Espaço reservado para anúncio', // Texto a exibir no placeholder
  }
};

export default adsConfig;
